<template>
  <div>
    <vs-prompt
      title="Add edit data processor"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      accept-text="Add"
      :is-valid="validForm"
      class="todoPopup"
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Example: NightPay ApS"
                v-model="dataProcessor.name"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>VAT Number</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Example: 37987204"
                v-model="dataProcessor.vat"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Street</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Example: Skindergade 7"
                v-model="dataProcessor.street"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Zip code</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Example: 2550"
                v-model="dataProcessor.zip"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>City</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Example: København"
                v-model="dataProcessor.city"
              />
            </div>
          </div>

          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Country</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input
                class="inputx w-full"
                placeholder="Example: København"
                v-model="dataProcessor.country"
              />
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      prompt: false,
    };
  },
  computed: {
    validForm() {
      return true;
    },
    ...mapGetters({
      dataProcessor: "legalDocuments/dataProcessor",
    }),
  },
  methods: {
    show() {
      this.prompt = true;
    },
    async accept() {
      this.$vs.loading();

      await this.$store.dispatch(
        "legalDocuments/updateDataProcessor",
        this.dataProcessor
      );

      this.$vs.notify({
        color: "success",
        title: `Updated`,
        text: "Updated",
      });
      this.$vs.loading.close();
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
